export type PlatformsType = 'site' | 'dashboard' | 'editor';

export interface RedirectServiceUrlOptions {
  platform: PlatformsType;
  siteId?: string;
  appId?: string;
  versionOverrideId: string;
}

export function getRedirectServiceUrl({
  platform,
  siteId,
  appId,
  versionOverrideId,
}: RedirectServiceUrlOptions) {
  const redirectUrl = new URL(
    'https://dev.wix.com/wix-cli-redirect-service/redirect'
  );

  redirectUrl.searchParams.set('platform', platform);
  redirectUrl.searchParams.set('versionOverrideId', versionOverrideId);

  if (siteId) {
    redirectUrl.searchParams.set('tenantId', siteId);
  }

  if (appId) {
    redirectUrl.searchParams.set('appId', appId);
  }

  return redirectUrl.toString();
}
